import { render, staticRenderFns } from "./claimPoin.vue?vue&type=template&id=323ac3e4&"
import script from "./claimPoin.vue?vue&type=script&lang=js&"
export * from "./claimPoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports